import styled from 'styled-components';
import tw, {css} from 'twin.macro';
import TitleHeader from '../TitleHeader/TitleHeader';

export const CustomDataLeafElement = styled.div(({ $level }) => [
  css`
    &:nth-child(2) {
      ${tw`pt-16`}
    }
  `,
  tw`pb-16 pr-16`,
  $level < 2 ? tw`pl-16` : tw`pl-32`
]);

export const CustomDataGroupSpacer = styled.div(() => [tw`pb-16`]);

export const CustomDataGroupHeader = styled(TitleHeader)(() => [tw`pl-16 pr-16`]);
export const CustomDataBlockHeader = styled(TitleHeader)(() => [tw`pl-32 pr-16`]);
